module.exports = __webpack_public_path__ + "static/enquiries-14d186dfaf2db8b74eaa8b0f0ab89cd2.svg";